var base = base || {};


// Showing/hiding header on scroll
//-----------------------------------------------------------------
base.toggleHeader = function() {

    var $header = $('.header'),
        headerHeight = $header.outerHeight(),
        lastScrollTop = 0,
        offset = 5,
        _vw = $(window).width(),
        didScroll;

    if (!$header.length) {
        return;
    }

    $(window).scroll(function(event){
        didScroll = true;
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 200);

    function hasScrolled() {
        var st = $(this).scrollTop();

        if (Math.abs(lastScrollTop - st) <= offset) {
            return;
        }

        if (st > lastScrollTop && st > headerHeight){
            // Scroll down
            $header.removeClass('nav_down').addClass('nav_up');
            // $('.sticky').css('top', '20' + 'px');
        }
        else if (st + $(window).height() < $(document).height()) {
            // Scroll up
            $header.removeClass('nav_up').addClass('nav_down');
            // $('.sticky').css('top', '160' + 'px');
        }
        
        if ($(window).scrollTop() <= 10) {
            $header.removeClass('nav_down nav_up');
            // $('.sticky').removeAttr('style');
        }

        lastScrollTop = st;
    }


    // change the styling of header when hover
    // if ( _vw > 980) {
    //     $('.menu__item').hover(function() {
    //         $('.header').css('background-color', '#333333');
    //     }, function() {
    //         // on mouseout, remove the style attribute to reset
    //         $('.header').removeAttr('style');
    //     });
    // }
};





$(document).ready(function (){
    base.toggleHeader();
});